/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../../components/Table";
import { getParams } from "../../utils/params";
import { get, isEmpty } from "lodash";
import {
  companyApproved,
  companyPause,
  getCompanies,
  getCompaniesExcelDownload,
} from "../../apis/admin/companies";
import Modal, { ModalHeader } from "../Modal";
import Managers from "../Manager/Mangers";
import useForm from "../../hooks/useForm";
import Filters from "../Filters";

import { COMPANY_STATE, PARTNER_COMPANY_TYPE, PARTNER_TYPE } from "../../constants/COMPANY";
import ToolTip from "../ToolTip/ToolTip";
import { comma } from "../../utils/number";
import PartnerCompany from "./PartnerCompany";
import Pertner from "../Partner/Partner";
import { transformMobile } from "../../utils/validator/mobile";
import { clipboardCopy } from "../../utils/browser";
import { viewLoading } from "../../utils/loading";
import { downExcelFile } from "../../utils/download";
import { shallowEqual, useSelector } from "react-redux";
import systemAlert from "../../utils/systemAlert";

const allPartnerCompanyTypes = PARTNER_COMPANY_TYPE.map(p => p.value);

const PartnerCompanies = () => {
  const { employee } = useSelector(store => ({
    employee: store.Profile.employee
  }), shallowEqual);


  const [fields] = useState([
    {
      title: "타입",
      label: "-",
      key: "type",
      className: "text-align-center",
      onValue: (val, fields, form) => {
        let type = "기업";
        switch (val) {
          case 2:
            type = "세무사";
            type += `\n(${form.code})`;
            break;
          case 3:
            type = "노무사";
            break;
          case 9:
            type = "경리대행";
            break;

          default:
            break;
        }
        return type;
      },
    },
    {
      title: "회사 타입",
      key: "isPartner",
      onValue: (v) => v ? <span className="color-main-100">파트너</span> : "일반"
    },
    {
      title: "상호", label: "-", key: "name", className: "text-align-center"
    },
    { title: "사업자번호", label: "-", key: "comNum", transform: "comNum" },
    {
      title: "대표자명",
      label: "-",
      key: "ceoName",
      onValue: (value, fileds, data) => {
        const ceos = data.employees.filter(
          (e) => get(e, "companyRoleEmployees[0].companyRole.type", null) === 1
        );
        return (
          <>
            {value}
            {!isEmpty(ceos) && (
              <ToolTip
                tooltiptext={ceos
                  .map(
                    (c) => `${c.name}(${c.userId}) / ${c.mobile} / ${c.email}`
                  )
                  .join("\n\n")}
                position="bottom"
              ></ToolTip>
            )}
          </>
        );
      },
    },
    {
      title: "회사신청자",
      label: "-",
      key: "user",
      onValue: (value) => {
        return (
          !value ? <>-</> : <>

            {value.name}
            <ToolTip
              tooltiptext={`${value.email}`}
              position="bottom"
            ></ToolTip>
          </>
        );
      },
    },
    {
      title: "핸드폰번호",
      label: "-",
      key: "user",
      onValue: (value) => {
        return (
          !value ? <>-</> : <>
            <span>{transformMobile(value.mobile)}</span>
          </>
        );
      },
    },
    {
      title: "담당 회사 수", label: "-", key: "allCareCompanies", onValue: (value) => {

        return (
          <>
            {comma(value.length)}개
            {!isEmpty(value) && (
              <ToolTip
                tooltiptext={value
                  .map(
                    (c) => `${c.name} (${c.comNum} / ${COMPANY_STATE.find(s => s.value === c.state).label})`
                  )
                  .join("\n\n")}
                position="bottom"
              ></ToolTip>
            )}
          </>
        );
      }
    },
    {
      title: "담당자 매칭된 담당회사", label: "-", key: "careCompanies", onValue: (value) => {

        return (
          <>
            {comma(value.length)}개
            {!isEmpty(value) && (
              <ToolTip
                tooltiptext={value
                  .map(
                    (c) => `${c.name} (${c.comNum} / ${COMPANY_STATE.find(s => s.value === c.state).label})`
                  )
                  .join("\n\n")}
                position="bottom"
              ></ToolTip>
            )}
          </>
        );
      }
    },
    {
      title: '가입일',
      key: 'createdTime',
      type: 'dateTime'
    },
    {
      title: "승인 상태",
      label: "-",
      key: "state",
      onTranslator: { list: COMPANY_STATE },
    },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      onValue: (value, fileds, data) => {
        return data.state === 1 ? "일시중지" : "승인";
      },
      onClick: ({ data }) => {
        if (data.state === 1) {
          companyPause(data.idx).then(() => {
            reSubmit();
          });
        } else {
          companyApproved(data.idx).then(() => {
            reSubmit();
          });
        }
      },
    },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      label: "매니징 수정",
      onClick: ({ data }) => {
        setManagerViewCompany(data);
      },
    },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      label: "파트너 정보 수정",
      onClick: ({ data }) => {
        setSelectedPartnerCompnay(data);
      },
    },
  ]);
  const [selectedPartnerCompnay, setSelectedPartnerCompnay] = useState(null);
  const [managerViewCompany, setManagerViewCompany] = useState(null);
  const [detailManageCompany, setDetailManageCompany] = useState(null);
  const {
    form,
    setSubmit,
    handleOnChange,
    reSubmit,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedList,
    setSelectedList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
  } = useForm({
    // searchType: 'name',
    // searchText: '',
    order: [
      {
        idx: "desc",
      },
    ],
    search: {
      type: allPartnerCompanyTypes
    },
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [page, limit]);

  const submit = (param) => {
    if (param.search.type === '') {
      param.search.type = allPartnerCompanyTypes;
    }
    if (param.search.isPartner === '') {
      delete param.search.isPartner;
    }
    param.order = [{ "idx": "desc", },];
    setIsLoading(true);

    getCompanies(getParams(param))
      .then((res) => {
        setTotal(get(res, "data.total"));
        setList(get(res, "data.companies"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
        setSelectedList([]);
      });
  };

  const [filters] = useState([
    {
      title: "타입",
      type: "select",
      key: "search.type",
      options: {
        list: [{ label: "전체", value: "" }, ...PARTNER_COMPANY_TYPE],
      },
    },
    {
      title: "회사타입",
      type: "select",
      key: "search.isPartner",
      options: {
        list: [{ label: "전체", value: "" }, ...PARTNER_TYPE],
      },
    },
    {
      title: "회사상태",
      type: "select",
      key: "search.state",
      defaultValue: "",
      options: {
        list: [{ label: "전체", value: "" }, ...COMPANY_STATE],
      },
    },
    {
      title: "상호",
      key: "search.name",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "사업자번호",
      key: "search.comNum",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "대표이름",
      key: "search.ceoName",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ]);

  const onRowClick = (data, e) => {
    if (e.target.tagName === "SPAN") {
      clipboardCopy(data?.user?.mobile, "핸드폰 번호가 복사되었습니다.");
    } else {

      setDetailManageCompany(data);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const _excelDownload = () => {

    systemAlert(`${employee?.name}님, 파트너 목록 다운로드를 진행하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소',
        }, {
          label: '확인',
          onClick: () => {
            const _params = getParams(form);
            viewLoading("엑셀 다운로드 중입니다.");
            getCompaniesExcelDownload(_params).then((res) => {
              downExcelFile(res, "파트너_목록.xlsx");
              viewLoading(false);
            });
          }
        }
      ]
    });
  };
  const tableButtons = [
    // 240716 세무사님 요청 임시 제거
    // {
    //   label: "엑셀 다운로드",
    //   action: _excelDownload
    // },
  ];
  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        onSelect={onRowClick}
        isControl={false}
        buttons={tableButtons}
      />
      <Modal
        isOpen={!!detailManageCompany}
        close={() => {
          setDetailManageCompany(null);
          reSubmit();
        }}
      >
        {detailManageCompany && (
          <>
            <ModalHeader>{detailManageCompany.name}</ModalHeader>
            <PartnerCompany
              company={detailManageCompany}
              setCompany={setDetailManageCompany}
            ></PartnerCompany>

          </>
        )}
      </Modal>
      <Modal
        isOpen={!!managerViewCompany}
        close={() => {
          setManagerViewCompany(null);
          reSubmit();
        }}
      >
        {managerViewCompany && (
          <>
            <ModalHeader>{managerViewCompany.name} 매니저 관리</ModalHeader>
            <Managers targetCompany={managerViewCompany}></Managers>
          </>
        )}
      </Modal>
      <Modal
        isOpen={!!selectedPartnerCompnay}
        close={() => {
          setSelectedPartnerCompnay(null);
          reSubmit();
        }}
      >
        {selectedPartnerCompnay && (
          <>
            <Pertner partnerCompany={selectedPartnerCompnay} />
          </>
        )}
      </Modal>
    </>
  );
};

export default PartnerCompanies;
